import React, { createContext, useContext } from 'react';
import {
  useComplianceSocket,
  ComplianceSocketState,
  ComplianceFinalResult,
  ComplianceQuestion,
} from '../hooks/useComplianceSocket';

interface ComplianceContextValue {
  state: ComplianceSocketState;
  start: (companyId: string, policyIds: string[], token: string, jurisdiction?: string) => void;
  resume: (sessionId: string, token: string) => void;
  reset: () => void;
  disconnect: () => void;
  setQuestions: (questions: ComplianceQuestion[]) => void;
  setFinalResult: (result: ComplianceFinalResult) => void;
}

const ComplianceContext = createContext<ComplianceContextValue | null>(null);

/**
 * Wraps the app at root level so compliance page state persists across tab
 * navigation while an assessment is running — mirrors GovernanceProvider /
 * RiskProvider one-for-one.
 */
export function ComplianceProvider({ children }: { children: React.ReactNode }) {
  const socket = useComplianceSocket();
  return (
    <ComplianceContext.Provider value={socket}>
      {children}
    </ComplianceContext.Provider>
  );
}

export function useCompliance(): ComplianceContextValue {
  const ctx = useContext(ComplianceContext);
  if (!ctx) throw new Error('useCompliance must be used inside <ComplianceProvider>');
  return ctx;
}
